import { useSelector } from "react-redux";
import { selectFeatureFlagData } from "store/featureFlag/featureFlagSelector";

const useFeatureFlag = () => {
  const { keycloakIntegrationEnabled: isKeycloakIntegrationEnabled } =
    useSelector(selectFeatureFlagData);
  return { isKeycloakIntegrationEnabled };
};

export default useFeatureFlag;
